'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaults = require('../defaults');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaults.DEFAULT_URL;
  return state;
};
//# sourceMappingURL=currentUrl.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-global-settings/dist/main/reducers/currentUrl.js
// module id = 521
// module chunks = 0